// exports CoderQAQueueStatus - an immutable object 'enum'
// usage: import { CoderQAQueueStatus } from '../../enums/CoderQAQueueStatus';
const coderQAQueueStatuses = {
    Unknown: 0,
    Building: 1,
    Closed: 9
};
Object.freeze(coderQAQueueStatuses);
export const CoderQAQueueStatus = coderQAQueueStatuses;